import { faBell, faRobot } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Card } from "react-bootstrap";
import moment from "moment";
import "moment/locale/es-mx";

export const NotificacionEventosRobo = ({ registroSeguridadEventos, index }) => {

    return (
        <>
            <div
                className="offcanvas offcanvas-end"
                tabIndex="-1"
                id="offcanvasRightNotificaciones"
                aria-labelledby="offcanvasRightLabel"
                data-bs-backdrop="false"
                data-bs-scroll="true"
            >
                <div className="offcanvas-header">
                    <h5
                        id="offcanvasRightLabel"
                        style={{
                            fontWeight: "bold",
                        }}
                    >
                        NOTIFICACIONES DE EVENTOS
                    </h5>
                    <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                        style={{ backgroundColor: "aliceblue" }}
                    />
                </div>
                <div className="offcanvas-body">
                    {registroSeguridadEventos.map((evt) => {
                        if (evt.finalizado === false) {
                            return (
                                <Card
                                    bg="light"
                                    text="dark"
                                    style={{
                                        width: "100%",
                                        borderBottom: "2px solid #ddcd43",
                                    }}
                                    className="mb-2"
                                    key={evt.unidad_id}
                                >
                                    <Card.Header>
                                        <div className="row">
                                            <div className="col-8">
                                                <p style={{ fontWeight: "bold", fontSize: "12px" }}>
                                                    {
                                                        evt.tipo_unidad_id === 3 || evt.tipo_unidad_id === 4 ? (
                                                            evt.unidad_vin ? (
                                                                `UNIDAD: ${evt.unidad_vin}`
                                                            ) : ""
                                                        ) : evt?.tipo_unidad_id === 1 ? (`UNIDAD: ${evt?.unidad?.unidad_numero}`) : ""
                                                    }
                                                </p>
                                            </div>
                                            <div className="col-4">
                                                <p style={{ fontWeight: "bold", fontSize: "12px" }}>
                                                    {
                                                        evt?.tipo_unidad_id === 3 ? `MOTO` :
                                                            evt?.tipo_unidad_id === 4 ? `AUTO` :
                                                                evt?.tipo_unidad_id === 1 ? `CAMION` : ""
                                                    }
                                                </p>
                                            </div>
                                        </div>
                                    </Card.Header>
                                    <Card.Body>
                                        <Card.Title>
                                            {
                                                evt.createdAt
                                                    ? moment(evt.createdAt)
                                                        .local()
                                                        .format("YYYY-MM-DD HH:mm:ss")
                                                    : ""
                                            }
                                        </Card.Title>
                                        <div className="col-12">
                                            <p style={{ fontSize: "15px", margin: "5px" }}>
                                                Nuevo evento de: {evt?.evento?.evento}
                                            </p>
                                            <p style={{ fontSize: "15px", margin: "5px" }}>
                                                {
                                                    evt.unidad.cliente ?
                                                        `Cliente: ${evt?.unidad?.cliente}` :
                                                        `Negocio: ${evt?.unidad?.negocio}`
                                                }
                                            </p>
                                            <p style={{ fontSize: "15px", margin: "5px" }}>
                                                {
                                                    evt?.unidad?.cedis && (`Cedis:${evt?.unidad?.cedis}`)
                                                }
                                            </p>
                                            <p style={{ fontSize: "15px", margin: "5px" }}>
                                                Estado: {evt?.estado?.entidad_federativa}
                                            </p>
                                            <p style={{ fontSize: "15px", margin: "5px" }}>
                                                Muninicipio: {evt?.municipio?.municipio}
                                            </p>
                                        </div>
                                    </Card.Body>
                                </Card>
                            );
                        }
                    })}
                </div>
            </div>

            <i
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightNotificaciones"
                aria-controls="offcanvasRight"
                className="notification m-3"
                key={registroSeguridadEventos.evento_seguridad_id}
            >
                <FontAwesomeIcon icon={faRobot} />
                <span className="badge badge-light">
                    {registroSeguridadEventos
                        ? registroSeguridadEventos.filter(
                            (item) => item.finalizado === false
                        ).length
                        : "0"}
                </span>
            </i>
        </>
    );
}